import Cookies from 'js-cookie';

const THEME_STORAGE_KEY = 'theme-preference';
const COOKIE_EXPIRY_DAYS = 365;
const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system'
};

function savePreference(mode) {
  try { localStorage.setItem(THEME_STORAGE_KEY, mode); } catch (e) { /* noop */ }
  try { Cookies.set(THEME_STORAGE_KEY, mode, { expires: COOKIE_EXPIRY_DAYS, sameSite: 'Lax' }); } catch (e) { /* noop */ }
}

function loadPreference() {
  let mode = null;
  try { mode = localStorage.getItem(THEME_STORAGE_KEY); } catch (e) { /* noop */ }
  if (!mode) {
    try { mode = Cookies.get(THEME_STORAGE_KEY); } catch (e) { /* noop */ }
    if (mode) {
      try { localStorage.setItem(THEME_STORAGE_KEY, mode); } catch (e) { /* noop */ }
    }
  }
  return mode || THEME_MODES.SYSTEM;
}

const state = {
  mode: THEME_MODES.SYSTEM,
  activeTheme: THEME_MODES.LIGHT
};

const getters = {
  mode: state => state.mode,
  activeTheme: state => state.activeTheme,
  isDark: state => state.activeTheme === THEME_MODES.DARK
};

const mutations = {
  SET_MODE(state, mode) {
    state.mode = mode;
  },
  SET_ACTIVE_THEME(state, theme) {
    state.activeTheme = theme;
  }
};

const actions = {
  initTheme({ commit, dispatch }) {
    const savedMode = loadPreference();
    commit('SET_MODE', savedMode);
    dispatch('applyTheme');

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', () => {
      if (state.mode === THEME_MODES.SYSTEM) {
        dispatch('applyTheme');
      }
    });
  },

  setMode({ commit, dispatch }, mode) {
    commit('SET_MODE', mode);
    savePreference(mode);
    dispatch('applyTheme');
  },

  applyTheme({ commit, state }) {
    let activeTheme;

    if (state.mode === THEME_MODES.SYSTEM) {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      activeTheme = prefersDark ? THEME_MODES.DARK : THEME_MODES.LIGHT;
    } else {
      activeTheme = state.mode;
    }

    commit('SET_ACTIVE_THEME', activeTheme);

    if (activeTheme === THEME_MODES.DARK) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }

    window.dispatchEvent(new CustomEvent('theme-changed', { detail: { theme: activeTheme } }));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
